import { useBadgeStyles } from "./UseBadgeStyles";
import { IBadgeProps } from "./IBadgeProps";

export function Badge(props: IBadgeProps): JSX.Element {
  const { count, maxCount = 99 } = props;
  const styles = useBadgeStyles();
  if (count <= 0) {
    return null;
  }

  const actualCount = count > maxCount ? `${maxCount}+` : count;
  return <div className={styles.root}>{actualCount}</div>;
}
